import RepositorySearch from "./RepositorySearch.js";
import messages from "../mixins/messages";

export default RepositorySearch.extend({
    mixins: [messages],
    props: {
        currentAcademicYear: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            endpoint: "/api/groups",
            type: null,
            options: {
                my_groups: true,
                student_type: null,
                enrollment_year: null,
            },
            sortColumn: "details.number",
            sortColumnDirection: "desc",
            syncOrder: {
                student_type: "asc",
                enrollment_year: true
            },
            modal: {
                active: false,
                modified: false,
                item: {
                    details: {}
                }
            },
            aggregateField: "student_count"
        };
    },
    computed: {
        courses() {
            let courses = [];

            let maxCourses = 4;

            if (this.type == 'graduate') {
                maxCourses = 3
            } else if (this.type == 'master') {
                maxCourses = 2
            }

            for (let course = 1; course <= maxCourses; course++) {
                let exists =
                    this.options.student_type == null ||
                    this.options.student_type == 'bachelor' ||
                    (this.options.student_type == 'master' && course <= 2) ||
                    (this.options.student_type == 'graduate' && course <= 3);

                courses.push({
                    number: course,
                    exists: exists,
                    enrollment_year: String(this.currentAcademicYear - (course - 1))
                });
            }

            return courses;
        }
    },
    methods: {
        mergeOptions: function (options) {
            return _.merge(
                {
                    type: this.type,
                },
                options
            );
        },
        modified() {
            this.modal.modified = true;
        },
        studentTypeLabel: function (group) {
            return this.messages.students.type[group.student_type];
        },
        open: function (item) {
            window.open(item.url, "_self");
        },
        create: function () {
            let loading = this.$loading.open();

            axios
                .get(`${this.endpoint}generate`, {
                    params: {
                        type: this.type,
                    }
                })
                .then(response => {
                    this.modal.item = response.data;
                    this.modal.active = true;
                    this.modified();
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    this.toast("error", "@unexpected", error, error);
                });
        },
        close: function () {
            this.modal.active = false;
        },
        save: function () {
            this.modal.modified = false;
            this.$refs.form.save().then(() => {
                this.close();
                this.search(true);
            });
        },
        onFilter() {
            if (!this.initialLoad) {
                this.options.enrollment_year = null;
            }
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/abstract/GroupIndex.js